export enum RoutePath {
  Login = '/login',
  Unauthorized = '/unauthorized',
  RootAdminLogin = '/admin',
  RegisterTenant = '/register/tenant',
  RegisterRootAdmin = '/register/root-admin',
  AdminAgreements = '/admin/agreements',
  AdminAgreement = '/admin/agreements/:id',
  AdminDisputes = '/admin/disputes',
  AdminDispute = '/admin/disputes/:id',
  AdminTransactions = '/admin/transactions',
  AdminUsers = '/admin/users',
  AdminMilestone = '/admin/agreements/:id/milestones/:milestoneId',
  AdminApiKey = '/admin/api-key',
  AdminPaymentProviders = '/admin/payment-providers',
  Organizations = '/organizations',
  Organization = '/organizations/:id',
  OrganizationProviders = '/organizations/:id/providers',
  Users = '/users',
  SharedBridgeWebhook = '/root-admin/shared-bridge-webhook',
  RootAdminSignup = '/root-admin/signup',
  Root = '/',
}

type RouteParams<RoutePathType extends RoutePath> = RoutePathType extends RoutePath.AdminAgreement
  ? {
      id: string
    }
  : RoutePathType extends RoutePath.AdminDispute
    ? {
        id: string
      }
    : RoutePathType extends RoutePath.AdminMilestone
      ? {
          id: number
          milestoneId: number
        }
      : RoutePathType extends RoutePath.Organization
        ? {
            id: string
          }
        : RoutePathType extends RoutePath.OrganizationProviders
          ? {
              id: string
            }
          : never

export function getRoutePath<RoutePathType extends RoutePath>(
  path: RoutePathType,
  params: RouteParams<RoutePathType>,
): string {
  const pathString = path.toString()

  return Object.entries(params).reduce((acc, [key, value]) => {
    return acc.replace(`:${key}`, value)
  }, pathString)
}
